module.exports = __webpack_public_path__ + "static/mujeres006.thumb-46586cd866b1a3adf1c6d33eb940388e.jpg";